
export class ProgramConfigurationNav {
  public static item = {
    title: 'program.tab.configuration',
    url: 'configuration',
    icon: '<img src="./assets/icons/line-icons/shared/grey/admin.svg" width="22px" height="22px">',
    testId: 'prog-nav-configuration',
  };
}
